/**
 * The eight sub-modules used to occupy half the viewport as identical pale
 * cards. They are navigation, not content — so they are a dense command rail.
 */
import { useNavigate } from 'react-router-dom';
import {
  Inbox, AlertTriangle, Gavel, GitBranch, CalendarClock, Wallet, Columns3, LayoutPanelTop,
} from 'lucide-react';

const LINKS = [
  { to: '/contracts/correspondence', label: 'Correspondence', icon: Inbox },
  { to: '/contracts/ld-exposure', label: 'LD Exposure', icon: AlertTriangle },
  { to: '/contracts/claims', label: 'Claims', icon: Gavel },
  { to: '/contracts/variations', label: 'Variations', icon: GitBranch },
  { to: '/contracts/obligations', label: 'Obligations', icon: CalendarClock },
  { to: '/contracts/payments', label: 'Payment & Retention', icon: Wallet },
  { to: '/contracts/compare', label: 'Comparison', icon: Columns3 },
  { to: '/contracts/single-project', label: 'Single project', icon: LayoutPanelTop },
];

export const QuickLaunchRail = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1" data-testid="quick-launch-rail">
      <span className="text-[10px] font-semibold uppercase tracking-[0.22em] shrink-0 pr-2"
            style={{ color: 'var(--text-muted)' }}>Workspaces</span>
      {LINKS.map(({ to, label, icon: Icon }) => (
        <button
          key={to}
          onClick={() => navigate(to)}
          className="shrink-0 inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs transition-colors focus-visible:outline-none focus-visible:ring-2"
          style={{ borderColor: 'var(--border-color)', color: 'var(--text-secondary)' }}
          onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--hover-bg)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          data-testid={`rail-${to.split('/').pop()}`}
        >
          <Icon className="w-3.5 h-3.5" />
          {label}
        </button>
      ))}
    </div>
  );
};

export default QuickLaunchRail;
